import React from "react";

function iso(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function presetRanges() {
  const now = new Date();
  const today = iso(now);
  const dow = (now.getDay() + 6) % 7; // 0 = Monday
  const ws = new Date(now); ws.setDate(now.getDate() - dow);
  const we = new Date(ws); we.setDate(ws.getDate() + 6);
  const ms = new Date(now.getFullYear(), now.getMonth(), 1);
  const me = new Date(now.getFullYear(), now.getMonth() + 1, 0);
  const ys = new Date(now.getFullYear(), 0, 1);
  const ye = new Date(now.getFullYear(), 11, 31);
  return {
    Today: [today, today],
    "This Week": [iso(ws), iso(we)],
    "This Month": [iso(ms), iso(me)],
    "This Year": [iso(ys), iso(ye)],
  };
}

export function QuickRange({ onPick, active }) {
  const r = presetRanges();
  return (
    <div className="flex flex-wrap gap-2" data-testid="quick-range">
      {Object.entries(r).map(([label, [s, e]]) => {
        const on = active && active[0] === s && active[1] === e;
        return (
          <button
            key={label}
            type="button"
            data-testid={`range-${label.toLowerCase().replace(/\s/g, "-")}`}
            onClick={() => onPick(s, e)}
            className={`h-9 px-3.5 rounded-full text-sm border transition-colors ${on ? "bg-primary text-primary-foreground border-primary" : "bg-card border-input hover:bg-muted"}`}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}
